const {log} = console
module.exports = function scaffoldProjectBrowser (state, emitter) {
  window.app = {state, emitter}
  emitter.on('navigate', args => {
    log('navigate', args)
    clearInterval(state.vmInterval)
    window.location.reload()
  })
}
